import React, { useState } from 'react';
import { Section } from './ui/Section';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  q: '¿Necesito computadora?',
  a: 'No. Está diseñado para hacerlo desde el celular.'
}, {
  q: '¿Y si no tengo idea qué PDF crear?',
  a: 'Justo por eso existe Heylloyd dentro del método: te da ideas y estructura.'
}, {
  q: '¿Tengo que ser buena escribiendo?',
  a: 'No. Vas a usar prompts y expansión por capítulos. Tu trabajo es editar y adaptar.'
}, {
  q: '¿Dónde lo vendo?',
  a: 'Puedes empezar por WhatsApp e Instagram (simple y rápido). Luego escalar a Etsy/Gumroad si quieres.'
}, {
  q: '¿Esto funciona si tengo pocos seguidores?',
  a: 'Sí, porque el plan incluye contacto directo y mensajes listos. No dependes de ser influencer.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section className="bg-gray-50" data-id="element-39">
      <h2 className="text-3xl font-bold text-gray-900 mb-10 text-center" data-id="element-40">
        Preguntas Frecuentes
      </h2>

      <div className="space-y-4 max-w-2xl mx-auto" data-id="element-41">
        {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-xl overflow-hidden bg-white" data-id="element-42">
            <button className="w-full flex items-center justify-between p-5 text-left hover:bg-gray-50 transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-43">
              <span className="font-semibold text-gray-900 pr-4" data-id="element-44">{faq.q}</span>
              {openIndex === index ? <ChevronUp className="w-5 h-5 text-brand-pink flex-shrink-0" data-id="element-45" /> : <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-46" />}
            </button>

            {openIndex === index && <div className="p-5 pt-0 bg-white text-gray-600 leading-relaxed border-t border-gray-100" data-id="element-47">
                <div className="mt-4" data-id="element-48">{faq.a}</div>
              </div>}
          </div>)}
      </div>
    </Section>;
}